export default __webpack_public_path__ + "static/media/640_dummy2016-klempner01-de.57f8ab51.png";